export default {
  '立即注册，解锁更多精彩内容': 'Register now to unlock more exciting content',
  '注册/登录': 'Register log in'
}
